import { defineStore } from 'pinia';
import { axiosApi } from 'src/utils/axios';

import { useAppSettingsStore } from './useAppSettingsStore';
import { useGlobalStore } from './useGlobalStore';
export const useHoraireStore = defineStore('Horaire', {
  persist: true,
  state: () => ({ horaireSemaine: {}, dayPunch: null }),
  actions: {
    async updateSemaineHoraire({ commit, state, rootState }, payload) {
      const AppSettings = useAppSettingsStore();
      const GlobalStore = useGlobalStore();
      const isEmployeMode = AppSettings.employeMode.active && AppSettings.employeMode.employe ? `&id=${AppSettings.employeMode.employe.id}` : '';

      try {
        const response = await axiosApi.get(`horaire?date=${GlobalStore.virtualDate}${isEmployeMode}`);
        this.horaireSemaine = { ...response.data, updated: new Date() };
        return true;
      } catch (error) {
        // showErrorNotification(`Pas d'accès internet.`);
        return false;
      }
    },

    async confirmerPresence(payload) {
      try {
        const response = await axiosApi.post('presences/manualPunch', payload);
        return response.data;
      } catch (error) {
        // showErrorNotification(`Pas d'accès internet.`);
        return false;
      }
    },
    setlastStepSynced(payload = null) {
      const dayPunch = this.dayPunch[payload.date];
      dayPunch.lastStepSynced = payload.step;
      this.dayPunch = {};
      this.dayPunch[payload.date] = dayPunch;

      // LocalStorage.set('dayPunch', state.dayPunch);
    }
  }
});
